module.exports = __webpack_public_path__ + "assets/img/ACH1.e9e2113a.svg";